<template>
  <v-checkbox
    dense 
    v-model="localValue"
    v-bind="$props"
    @change="handleChange"
  ></v-checkbox>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      required: false
    },
    label: String,
    disabled: Boolean,
    color: String
  },
  data() {
    return {
      localValue: undefined
    }
  },
  mounted() {
    this.localValue = Boolean(this.value)
  },
  methods: {
    handleChange(obj) {
      this.$emit('change', obj)
    }
  },
  watch: {
    localValue: {
      handler(newValue) {
        if (newValue === null) {
          this.localValue = false
        }
        this.$emit('change', newValue)
        this.$emit('input', newValue)
      }
    },
    value: {
      handler() {
        this.$emit('change', this.value)
        this.$emit('input', this.value)
      }
    }
  }
}
</script>

<style>
</style>
